import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';
import { DocumentsTableFeature } from 'modules/client/common/feature/DocumentsTableFeature';
import { Field } from 'modules/client/legal/forms/openAccountOrderForm';

export const OpenAccountOrderSection = () => {
  const { t } = useTranslation();

  return (
    <Section
      datax="openAccountOrderSection"
      title={t('client.openAccountOrder.title')}
    >
      <GridFields>
        <Field.Text
          fullWidth
          label={t('client.openAccountOrder.number.label')}
          name="openAccountOrder_Finance.number"
          placeholder={t('client.openAccountOrder.number.placeholder')}
        />
        <Field.DatePicker
          fullWidth
          disableFuture={false}
          label={t('client.openAccountOrder.date.label')}
          name="openAccountOrder_Finance.date"
          placeholder={t('client.openAccountOrder.date.placeholder')}
        />
        <Field.DatePicker
          fullWidth
          disableFuture={false}
          label={t('client.openAccountOrder.orderReceivedDate.label')}
          name="openAccountOrder_Finance.orderReceivedDate"
          placeholder={t(
            'client.openAccountOrder.orderReceivedDate.placeholder'
          )}
        />
      </GridFields>
      <DocumentsTableFeature
        maxDocumentCount={1}
        name="openAccountOrder_Finance.document"
      />
    </Section>
  );
};
